import { Flex, useToast } from '@chakra-ui/react';
import { handleSwapCreation } from '../blockchain/client/interact';
import { IAssetInPortfolio, IPortfolioState, WalletData } from '../types';
import StepButtons from './step-buttons';

interface InsufficientTokensProps {
  wallet?: WalletData | null;
  apiBaseUrl: string;
  portfolio: IPortfolioState;
  totalInput: bigint;
  swapDeficit: boolean;
  setSwapDeficit: (val: boolean) => void;
  swapBalances: MintModalBalances;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setTxHash: React.Dispatch<React.SetStateAction<string | null>>;
}

export interface MintModalBalances {
  [key: string]: {
    asset: IAssetInPortfolio['asset'];
    // Tokens currently in wallet
    owned: bigint;
    // Tokens required to deposit
    required: bigint;
    // Tokens that will be swapped
    deficit: bigint;
  };
}

const InsufficientTokens = ({
  wallet,
  apiBaseUrl,
  portfolio,
  totalInput,
  setSwapDeficit,
  swapDeficit,
  swapBalances,
  setLoading,
  setTxHash,
}: InsufficientTokensProps) => {
  const toast = useToast();

  const errorToast = (title: string, description: string) =>
    toast({
      title: title,
      description: description,
      status: 'error',
      isClosable: true,
      position: 'top-right',
    });
  const handleSwapClick = async () => {
    if (!wallet?.wallet) {
      errorToast('Must connect wallet', 'Please connect your wallet first');
      return;
    }
    setLoading(true);

    const assetsRequired: Record<string, bigint> = {};
    const assetsInWallet: Record<string, bigint> = {};
    for (const [, assetBalance] of Object.entries(swapBalances)) {
      assetsRequired[assetBalance.asset.id] = assetBalance.required;
      assetsInWallet[assetBalance.asset.id] =
        assetBalance.owned > assetBalance.required
          ? assetBalance.required
          : assetBalance.owned;
    }
    await handleSwapCreation(
      wallet,
      portfolio,
      assetsInWallet,
      assetsRequired,
      totalInput,
      swapDeficit,
      apiBaseUrl,
      {
        onError: (msg) => {
          errorToast('Error', msg);
          setLoading(false);
        },
        onSuccess: (txHash) => {
          toast({
            isClosable: true,
            status: 'success',
            title: 'Transaction submitted',
            description: `TxHash: ${txHash}`,
            position: 'top-right',
          });
          setTxHash(txHash);
          setLoading(false);
        },
      },
    );
  };
  return (
    <Flex
      flexDir="column"
      justifyContent={'center'}
      align="center"
      fontSize={'0.75rem'}
      width={'full'}
      display={'block'}
    >
      {/* <SwapDeficitSwitch
        setSwapDeficit={setSwapDeficit}
        swapDeficit={swapDeficit}
      /> */}
      <StepButtons
        rightOnclick={handleSwapClick}
        rightText="Zap-in"
        rightBtnProps={{
          backgroundColor: 'var(--metera-yellow)',
          border: 'none',
          color: 'black',
          maxH: '3rem',
          height: '100%',
          borderRadius: '62.5rem',
          padding: '1rem',
          width: '100%',
        }}
      />
    </Flex>
  );
};

export default InsufficientTokens;
